import MyFilter from "./MyFilter";
import { Box, IconButton, Typography } from "@mui/material";
import { useTheme } from "@mui/material";
import { CloseIcon } from "../../../../components/Icons";

export default function ListFilterMain(props) {
  const { selectFilter, setSelectFilter, payLoadData, setPayloadData } = props;
  const clearFilterdata = (item) => {
    let data = selectFilter;
    let requestData = payLoadData;
    if (data.indexOf(item) !== -1) {
      let indexNo = data.indexOf(item);
      data.splice(indexNo, 1);
      if ("Activate Date" === item) {
        requestData.activeDateEnd = "";
        requestData.activeDateStart = "";
      }
      if ("Expire Date" === item) {
        requestData.expiryDateStart = "";
        requestData.expiryDateEnd = "";
      }
      if ("Customer" === item) {
        requestData.userId = "";
      }
      if ("Scratch Event" === item) {
        requestData.scratchEventId = "";
      }
      // if ("Statement" === item) {
      //   requestData.statement = "";
      // }
    }
    if (item === "clearall") {
      // requestData.paymentType = [];
      requestData.activeDateEnd = "";
      requestData.activeDateStart = "";
      requestData.expiryDateStart = "";
      requestData.expiryDateEnd = "";
      requestData.status = "";
      requestData.userId = "";

      if (requestData.hasOwnProperty("scratchEventId")) {
        requestData.scratchEventId = "";
      }
      data = [];
    }
    props.setReqData({ ...requestData });
    setSelectFilter(data);
  };
  const { palette } = useTheme();
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        gap: 1
      }}
    >
      <MyFilter
        {...props}
        payLoadData={payLoadData}
        setPayloadData={setPayloadData}
        selectFilter={selectFilter}
        setSelectFilter={setSelectFilter}
        clearFilterdata={clearFilterdata}
      />
      {selectFilter.length > 1 && (
        <Box
          sx={{
            p: "2px 4px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            border: 1,
            borderRadius: "4px",
            borderColor: "#bdbdbd",
            background: palette.mode === "dark" ? palette.grey[900] : palette.grey[300]
          }}
        >
          <Typography variant="span" sx={{ fontSize: "13px" }}>
            Clear all
          </Typography>
          <IconButton
            sx={{ color: "#f44336", p: "2px", ml: 0.5, background: "#e5e4e4", borderRadius: "50%" }}
            onClick={() => {
              clearFilterdata("clearall");
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
      )}
      {selectFilter.length > 0 &&
        selectFilter.map((item, i) => (
          <Box
            key={i}
            sx={{
              p: "2px 4px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              border: 1,
              borderRadius: "4px",
              borderColor: "#bdbdbd"
            }}
          >
            <Typography variant="span" sx={{ fontSize: "13px" }}>
              {item}
            </Typography>
            <IconButton
              sx={{ color: "#f44336", p: "2px", ml: 0.5, background: "#e5e4e4", borderRadius: "50%" }}
              onClick={() => {
                clearFilterdata(item);
              }}
            >
              <CloseIcon sx={{ fontSize: "11px" }} />
            </IconButton>
          </Box>
        ))}
    </Box>
  );
}
